import {Component, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {DashboardCUIDModel, DashboardDataService} from "@app/services/dashboard-data/dashboard-data.service";
import {CreditUnionService} from "@app/services/credit-union/credit-union.service";
import {MatTableDataSource} from "@angular/material/table";
import {GlobalSpinnerService} from "@app/services/misc-services/global-spinner.service";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {BehaviorSubject} from "rxjs";
import {finalize, shareReplay} from "rxjs/operators";
import {PortalUser} from "@app/model/portal-user.model";
import {CreditUnion} from "@app/pages/admin/admin.component";

@Component({
    selector: 'flex-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit, OnDestroy {
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort = new MatSort();
    cuid: string = 'None';
    selectedCategory: string = 'All';
    columns: string[] = ['cuid', 'logins', 'username', 'lastSignin'];
    displayedColumns: Array<{ label: string, value: string }> = [
        {label: 'Credit Union', value: 'cuid'},
        {label: 'Login Count', value: 'logins'},
        {label: 'Last User Logged In', value: 'username'},
        {label: 'Last Login Date', value: 'lastSignin'}];
    needsRefresh = false;
    dashboardDataSource: MatTableDataSource<DashboardCUIDModel> = new MatTableDataSource<DashboardCUIDModel>([]);
    allPortalUsers: BehaviorSubject<PortalUser[]> = new BehaviorSubject<PortalUser[]>([]);
    creditUnions: BehaviorSubject<CreditUnion[]> = new BehaviorSubject<CreditUnion[]>([]);

    constructor(public dashBoardDataService: DashboardDataService, public creditUnionService: CreditUnionService, private globalSpinner: GlobalSpinnerService) {
    }

    ngOnInit() {
        this.allPortalUsers = this.creditUnionService.getAllPortalUsers();
        this.creditUnionService.getAllCreditUnions().subscribe((creditUnions: CreditUnion[]) =>
            this.creditUnions.next(creditUnions));
        this.dashBoardDataService.loadCreditUnions();
    }

    //sets the filter for the dashboard tab and reloads/filters data
    setDashboardFilterValue(key: 'start' | 'end' | 'cuid' | 'cat', value) {
        switch (key) {
            case "start":
                this.dashBoardDataService.dashboardFilter.dateRange.start = value;
                break;
            case "end":
                if (value != null) {
                    this.dashBoardDataService.dashboardFilter.dateRange.end = value;
                    this.dashBoardDataService.loadData();
                }
                break;
            case "cuid":
                this.dashBoardDataService.dashboardFilter.cuid = value;
                this.dashBoardDataService.loadData();
                break;
            case "cat":
                this.dashBoardDataService.dashboardFilter.cat = value;
                this.dashBoardDataService.loadData();
                break;
        }
    }

    //sets cuid filter and reloads/filters data if it changed cuid
    setCUIDFilterValue(key: 'start' | 'end' | 'cuid', value) {
        if (value) {
            this.needsRefresh = true;
        }
        switch (key) {
            case "start":
                this.dashBoardDataService.cuidFilter.dateRange.start = value;
                break;
            case "end":
                this.dashBoardDataService.cuidFilter.dateRange.end = value;
                break;
            case "cuid":
                this.dashBoardDataService.cuidFilter.cuid = value;
                this.refreshCUIDData();
                break;
        }
    }

    //reloads/filters data if date changed
    reloadOnDateChange() {
        if (this.needsRefresh) {
            this.refreshCUIDData();
        }
    }

    //used to set cuid data
    refreshCUIDData() {
        this.dashBoardDataService.loadCUIDCount().pipe(finalize(() => {
            this.globalSpinner.removeEvent('loadCUIDCount')
        }), shareReplay(1)).subscribe((data: Array<DashboardCUIDModel>) => {
            this.dashboardDataSource = new MatTableDataSource(data);
            this.dashboardDataSource.sort = this.sort;
            this.dashboardDataSource.paginator = this.paginator;
        });
        this.needsRefresh = false;
    }

    ngOnDestroy(){
        // this.allPortalUsers.complete();
        this.creditUnions.complete();
    }
}


